import { clearCache } from "../utils/cache";
import { getCall, postCall, putCall, sendBeacon } from "../utils/calls";
import {
  dispatchErrorMessage,
  loadingToast,
  updateToast,
} from "../utils/toast";

export const login = async (data) => {
  const res = await postCall("/login", data);
  return res;
};

export const signup = async (data) => {
  const { password2, ...dataToSend } = data;
  const res = await postCall("/signup", dataToSend);
  return res;
};

export const getMe = async () => {
  const res = await getCall("/me");
  if (res[0]) {
    return res[0];
  } else return null;
};

export const editUser = async (user) => {
  const id = loadingToast();
  const res = await putCall("/edit", user);
  if (res[0]) {
    updateToast(id, "success", "Información editada correctamente");
    return res[0];
  } else {
    dispatchErrorMessage(id, res, "Error al editar la información");
    return null;
  }
};

export const changePasswordCall = async (pass) => {
  const id = loadingToast();
  const res = await putCall("/change-password", pass);
  if (res[0]) {
    updateToast(id, "success", "Contacto editado correctamente");
    return res[0];
  } else {
    dispatchErrorMessage(id, res, "Error al editar el contacto");
    return null;
  }
};

export const logout = async () => {
  updateUserConnectionStatus(false);
  const res = await postCall("/logout", {});
  await clearCache();
  return res;
};

export const recoveryPass = async (email) => {
  let data = { username: email };
  const res = await postCall("/forgot", data);
  return res;
};

export const saveNewPassword = async (token, pass) => {
  let data = { password: pass };
  const res = await postCall("/forgot/" + token, data);
  return res;
};
export const updateUserConnectionStatus = async (isConnected) => {
  if (!localStorage.getItem("jwt")) return;
  const data = {
    // last_seen: new Date(),
    connected: isConnected,
    connection_downlink: navigator?.connection?.downlink,
    connection_effective_type: navigator?.connection?.effectiveType,
    connection_rtt: navigator?.connection?.rtt,
    user_agent: navigator?.userAgent,
    platform: navigator?.platform,
  };
  const res = await postCall("/update-connection-status", data);
  return res;
};
export const getAllUserConnectionStatus = async () => {
  const res = await getCall("/user-connection-status");
  if (res[0]) {
    return res[0].user_connections;
  } else return null;
};
export const getBotStates = async () => {
  const res = await getCall("/bots/info");
  if (res[0]) {
    return res[0];
  } else return null;
};

export function sendUserDisconnectedStatusBeacon() {
  const data = {
    // last_seen: new Date(),
    connected: false,
    connection_downlink: navigator?.connection?.downlink,
    connection_effective_type: navigator?.connection?.effectiveType,
    connection_rtt: navigator?.connection?.rtt,
    user_agent: navigator?.userAgent,
    platform: navigator?.platform,
  };
  sendBeacon("/update-connection-status/beacon", data);
}
